// extracted by mini-css-extract-plugin
module.exports = {"Video":"Video_Video__d1Yo0"};